import { render, staticRenderFns } from "./T1HotelCarousel.vue?vue&type=template&id=562e6ab1&scoped=true&"
import script from "./T1HotelCarousel.vue?vue&type=script&lang=js&"
export * from "./T1HotelCarousel.vue?vue&type=script&lang=js&"
import style0 from "./T1HotelCarousel.vue?vue&type=style&index=0&id=562e6ab1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562e6ab1",
  null
  
)

export default component.exports